import type { ReactNode } from "react";

export function PageHeading({ number, title, description, action }: { number: string; title: string; description?: string; action?: ReactNode }) {
  return (
    <header className="page-heading">
      <div className="page-number" aria-hidden="true">{number}</div>
      <div className="page-heading-copy">
        <h1>{title}</h1>
        {description && <p>{description}</p>}
      </div>
      {action && <div className="page-heading-action">{action}</div>}
    </header>
  );
}
